export default "<router-outlet></router-outlet>\r\n"